// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"WP-z","inlineTitle":"XP-z","sponsoredAdsWrapper":"YP-z","marketplaceRecosWrapper":"ZP-z"};